// import logo from './logo.svg';
// import './App.css';
import {Routes, Route} from "react-router-dom"
import Landing from "./Pages/Landing/Landing";
import Courses from "./Pages/Courses/Courses";
import CourseCarousel from "./Components/CourseCarousel/CourseCarousel";
import Organisation from "./Pages/Organisation/Organisation";
import CoursesWhole from "./Pages/CoursesWhole/CoursesWhole";
import MoreInfo from "./Pages/MoreInfo/MoreInfo";
import AdminDB from "./Pages/AdminDB/AdminDB";
import Login from "./Pages/Login/Login";
import LoginWhole from "./Pages/LoginWhole/LoginWhole";
import Home from "./Pages/Home/Home";
import RequireAuth from "./Components/RequireAuth/RequireAuth";
import PersistLogin from "./Components/PersistLogin/PersistLogin";
import Student from "./Components/Students/Students";
import Applicants from "./Components/Applicants/Applicants";
import Coursesz from "./Components/Courses/Courses";
import FileTable from "./Pages/FileView";
import PaymentSection from "./Pages/Payment/PaymentSection";

import Recovery from "./Pages/Recovery/Recovery"
import EmployeeView from "./Pages/EmployeeView/EmployeeView";
import ReactGA from "react-ga4";

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//use ToastContainer theme="dark"   


import { PrimeReactProvider, PrimeReactContext } from 'primereact/api';


// import StudentNumberForm from './components/StudentNumberForm';
// import StudentDetails from './components/StudentDetails';
// import PaymentRedirect from './components/PaymentRedirect';

     



import { useState } from "react";
import Intakes from "./Components/Intakes/Intakes";
import StudentNumberForm from "./Components/Payments/StudentNumberForm/StudentNumberForm";
import StudentDetails from "./Components/Payments/StudentDetails/StudentDetails";
import PaymentRedirect from "./Components/Payments/PaymentRedirect/PaymentRedirect";

// useState

function App() {

  ReactGA.initialize("G-BY1JFTC85C");

  const allowedRoles = {
    "Student":  "Student",
    "Lecturer" : "Lecturer",
    "Admin" : "Admin",
  }

  const [courseSel, setCourseSel] = useState([]);

  const handlePickCourse = (item) =>{ 

      console.log("mother clicks",item)
      // console.log("mother clicks",courseSel)
      const updatedClick = setCourseSel({item})
      console.log("mother clicks 2",courseSel)
       
     
  }
  return (
        <>  

            <Routes>
            {/* <Route element={<PersistLogin />}>
            </Route> */}
                  <Route element={<PersistLogin />}>  
                        <Route  path="/" element={<Landing />}>
                        
                        </Route>

                  </Route>
                    
                <Route element={<PersistLogin />}>  
                   <Route path="/Courses/:CID" element={<Courses onButtonClick = {handlePickCourse} />}>
                  
                   </Route>
                </Route>


                <Route path="/Recovery/:token" element={<Recovery/>}>

                </Route>

                <Route element={<PersistLogin />}>  
                      <Route path="/CoursesWhole" element={<CoursesWhole/>}>
                        
                        </Route>
                </Route> 
                
                <Route element={<PersistLogin />}>
                <Route element={<RequireAuth allowedRoles={[allowedRoles.Admin]}/>}> 

                     <Route path="/profile" element={<EmployeeView/>}>
                  
                </Route> 

                </Route>
                </Route>
                
                <Route path="/Organisations" element={<Organisation/>}>
                  
                </Route>


                <Route path="/FileTable" element={<FileTable/>}>
                  
                </Route>

                <Route element={<PersistLogin />}>  
                      <Route path="/MoreInfo" element={<MoreInfo/>}>
                        
                        </Route>
               </Route>


                <Route element={<PersistLogin />}>
                  <Route element={<RequireAuth allowedRoles={[allowedRoles.Admin]}/>}>  

                                        <Route path="/Admin" element={<AdminDB/>}>
                                          <Route path="/Admin/students" element={<Student/>}>
                                            
                                          </Route>
                                          <Route path="/Admin/Applicants" element={<Applicants/>}>
                                            
                                          </Route>
                                          <Route path="/Admin/Courses" element={<Coursesz/>}>
                                            
                                          </Route>
                                          <Route path="/Admin/Intakes" element={<Intakes/>}>
                                            
                                          </Route>
                                        
                                      </Route>



                  </Route>
                  </Route>

              
                <Route path="/payment" element={<PaymentSection/>}>

                  
                </Route>
                <Route path="/Login" element={<Login/>}>

                  
                </Route>
                <Route element={<PersistLogin />}>
                  <Route element={<RequireAuth allowedRoles={[allowedRoles?.Student,allowedRoles.Lecturer,allowedRoles.Admin]}/>}>
                          <Route path="/Home" element={<Home courseSel={courseSel}/>}>
                            
                            </Route>
                  </Route>
                </Route>
                
                <Route path="/Y" element={<CourseCarousel/>}>
                  
                </Route>

                 
       

               
                  <Route path="/indopay" element={<StudentNumberForm />} >
                  </Route>
                  <Route path="/details" element={<StudentDetails />} >
                  </Route>
                  <Route path="/redirect" element={<PaymentRedirect />} >
                  </Route>
               


                
           

                
            </Routes>

      
        </>
  );
}

export default App;
